import { useCallback } from "react";
import ReadFile from "../components/readFile";
function useDownloadCsv(data, name = "file.csv") {
  const download = useCallback(async () => {
    const readFile = new ReadFile();
    const csv = await readFile.generateNewCSV(data);
    const url = window.URL.createObjectURL(csv);
    const link = document.createElement("a");
    link.href = url;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }, [data]);

  return {
    download,
  };
}

export default useDownloadCsv;
